import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { asyncRequest, Entities, fetchById, search, TOMCAT_URL } from 'src/common';
import CustomTooltip from 'src/components/misc/CustomTooltip';
import OpenFolderIcon from 'material-ui/svg-icons/file/folder-open';
import { blue700, green700, red400 } from 'material-ui/styles/colors';
import ClosedFolderIcon from 'material-ui/svg-icons/file/folder';
import { OfferStatus } from 'src/utils/constants';
import { IconLabel } from 'src/components/administration/IconLabel';

class BusRequestDetailsModal extends Component {
    state = {
        expandedStops: {},
    };

    toggleStopExpansion = index => {
        this.setState(prevState => ({
            expandedStops: {
                ...prevState.expandedStops,
                [index]: !prevState.expandedStops[index],
            },
        }));
    };

    componentWillMount() {
        const { busRequest, t, handleClose } = this.props;
        if (busRequest.returnTrip)
            busRequest.intermediates.push({
                timeAndLocation: {
                    location: busRequest.to.location,
                    time: busRequest.returnTripDate,
                },
                time: busRequest.returnTripDate,
            });
    }

    render() {
        const { busRequest, t, handleClose } = this.props;
        const { expandedStops } = this.state;

        if (!busRequest) {
            return <div>{t('common_phrases.loading')}</div>;
        }

        const renderSimpleStop = stop => (
            <div className="card-stop">
                <span className="location-address">{stop.location.address}</span>
                {stop.time && <span className="location-time">{moment(stop.time).format('DD.MM.YYYY HH:mm')}</span>}
            </div>
        );

        return (
            <>
                {this.renderBusRequestContext(busRequest)}
                <div className="col-md-12">
                    <div className="details-container-bus-requests">
                        <div className="col-md-6">
                            <legend>{t('bus_requests.modal.journey_plan')}</legend>
                            <div className="col-md-12">
                                <button
                                    className="btn btn-xs btn-link nav-link "
                                    onClick={() => {
                                        asyncRequest(
                                            `${TOMCAT_URL}api/${Entities.BUS_REQUESTS.repository}/create-link/${busRequest.id}`,
                                        )
                                            .then(response => {
                                                const json = response.json;
                                                if (json && json.url) {
                                                    const win = window.open(json.url, '_blank');
                                                    if (win != null) win.focus();
                                                }
                                            })
                                            .catch(error => console.error('Error creating Link', error));
                                    }}>
                                    <IconLabel icon="edit" text={t('bus_requests.modal.create_offer')} />
                                </button>
                            </div>
                            <div className="col-md-12 journey-container">
                                <div className="timeline-item">{renderSimpleStop(busRequest.from)}</div>
                                <div className="intermediate-stops-container">
                                    {busRequest.intermediates.map((stop, index) => (
                                        <div className="timeline-item" key={index}>
                                            <div className="card-stop">
                                                <div className="card-stop-header">
                                                    <span className="location-address">
                                                        {stop.timeAndLocation.location.address}
                                                    </span>
                                                    {stop.comment && (
                                                        <button
                                                            onClick={() => this.toggleStopExpansion(index)}
                                                            className="expand-toggle-inline">
                                                            {expandedStops[index] ? (
                                                                <span className="glyphicon glyphicon-menu-down"></span>
                                                            ) : (
                                                                <span className="glyphicon glyphicon-menu-up"></span>
                                                            )}
                                                        </button>
                                                    )}
                                                </div>

                                                {stop.time && (
                                                    <span className="location-time">
                                                        {moment(stop.time).format('DD.MM.YYYY HH:mm')}
                                                    </span>
                                                )}

                                                {stop.comment && expandedStops[index] && (
                                                    <div className="comment-content-inline">
                                                        <span> {t('bus_requests.modal.customer_comment')}: </span>
                                                        <br />
                                                        {stop.comment}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                {busRequest.returnTrip ? (
                                    <div className="timeline-item">{renderSimpleStop(busRequest.from)}</div>
                                ) : (
                                    <div className="timeline-item">{renderSimpleStop(busRequest.to)}</div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col-md-12">
                                <legend>{t('bus_requests.modal.customer_info')}</legend>
                                <div className="customer-card">
                                    <span className="glyphicon glyphicon-user text-info" />
                                    <div className="customer-info">
                                        <span>{busRequest.customer.fullName}</span>
                                        <span className="customer-group">{busRequest.customer.name}</span>
                                        <span className="customer-group">{busRequest.customer.email}</span>
                                        <span className="customer-group">{busRequest.customer.phone}</span>
                                        <span className="customer-group">{busRequest.customer.address}</span>
                                    </div>
                                </div>
                            </div>
                            {busRequest.customerComment && (
                                <div className="col-md-12" style={{ marginTop: 10 }}>
                                    <legend> {t('bus_requests.modal.customer_comment')}</legend>
                                    <div className="customer-card">
                                        <div className="customer-info">{busRequest.customerComment}</div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className="col-md-12 ">
                    <button
                        className="btn pull-right"
                        style={{ margin: 10 }}
                        onClick={() => {
                            handleClose();
                        }}>
                        {t('bus_requests.modal.close')}
                    </button>
                </div>
            </>
        );
    }

    renderBusRequestContext(busRequest) {
        const { booking } = busRequest;
        const { t } = this.props;
        return (
            <>
                <div className="col-md-12">
                    {!busRequest.booking && (
                        <CustomTooltip text="Noch kein Angebot erstellt." place="bottom">
                            <OpenFolderIcon color={red400} />
                        </CustomTooltip>
                    )}
                    {booking && booking.offerDetails != null && (
                        <div
                            className="card-stop"
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '5px',
                                flexDirection: 'row',
                                marginBottom: '10px',
                            }}>
                            {booking.offerDetails.offerStatus === OfferStatus.OPEN && (
                                <div>
                                    <CustomTooltip text={t('bus_request.info.offer_already_created')} place="bottom">
                                        <ClosedFolderIcon color={blue700} />
                                    </CustomTooltip>
                                </div>
                            )}
                            {booking.offerDetails.offerStatus === OfferStatus.ACCEPTED && (
                                <div>
                                    <CustomTooltip text={t('bus_request.info.offer_accepted')} place="bottom">
                                        <ClosedFolderIcon color={green700} />
                                    </CustomTooltip>
                                </div>
                            )}
                            <div>
                                {booking.identifier}
                                {booking.offerDetails.offerStatus === OfferStatus.OPEN && (
                                    <>
                                        <br />
                                        {t('bus_requests.modal.booking.valid_until', {
                                            date: booking.offerDetails.validUntil,
                                        })}
                                    </>
                                )}
                                <br />
                                {t('bus_requests.modal.booking.price')}:{' '}
                                {booking.priceSummary.total.reduce((sum, price) => sum + price.amount, 0)}
                                {booking.priceSummary.total[0].currency}
                            </div>
                        </div>
                    )}
                </div>
            </>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        busRequest: ownProps.busRequest,
        selectedCompany: state.selectedCompany,
    };
};
export default connect(
    mapStateToProps,
    {
        fetchById,
        search,
    },
    null,
    { withRef: true },
)(BusRequestDetailsModal);
